import { NavLink } from "react-router-dom";
import cx from "clsx";

import "./Tile.less";

const Tile = ({ children, href, onClick, className, style }) => {
  const El = href ? NavLink : "div";
  return (
    <El
      to={href}
      className={cx("tile", className)}
      style={style}
      onClick={onClick ? onClick : null}
    >
      {children}
    </El>
  );
};

export default Tile;
